import { useNavigate } from 'react-router-dom';

import { Box, Stack, useTheme } from '@mui/material';

import { useGetUser } from '~modules/user/api/hooks/use-get-user';

import { PlanBadge } from '~components/layout/header/header.styles';
import { Notifications } from '~components/layout/header/notifications/notifications';
import { LoadingOverlay } from '~components/ui/loading-overlay/loading-overlay';
import { AppTypography } from '~components/ui/typography/app-typography';
import { UserAvatar } from '~components/ui/user-avatar/user-avatar';

import { useActiveScope } from '~hooks/use-active-scope';

import { ROUTES } from '~app/router/routes';

export const UserHeaderBadge = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const { data: user, isLoading } = useGetUser();

  const scope = useActiveScope();

  return (
    <LoadingOverlay loading={isLoading}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          marginLeft: {
            xs: 0,
            md: 'auto',
          },
          cursor: scope === 'lessor' ? 'pointer' : 'default',
        }}
        role={'button'}
      >
        <Notifications />

        <Stack
          role={'button'}
          direction={'row'}
          gap={1}
          alignItems={'center'}
          sx={{
            padding: {
              xs: 0,
              sm: theme.spacing(0.375, 0.75),
            },
            borderRadius: '6px',
            transition: '.1s background-color ease-in',
            '&:hover': {
              backgroundColor: scope === 'lessor' ? 'neutral.100' : 'inherit',
            },
          }}
          onClick={() => {
            if (scope === 'lessor') navigate(ROUTES.USER);
          }}
        >
          <UserAvatar userId={user?.id} size={{ xs: 36, md: 44 }} />

          <Box
            sx={{
              display: { sm: 'flex', xs: 'none' },
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <AppTypography
              weight="semibold"
              mb={0.5}
              sx={{ whiteSpace: 'nowrap' }}
            >
              {user?.firstname}
            </AppTypography>

            <PlanBadge plan={'trial'}>
              <AppTypography size="body-caption" weight="bold">
                Beta
              </AppTypography>
            </PlanBadge>
          </Box>
        </Stack>
      </Box>
    </LoadingOverlay>
  );
};
